import React, { useEffect, useState } from 'react';
import { mapOriginatingSystemToSource } from '../../../utilities/util';

const brightImg = require('./DisclosureImages/bright.png');
const cvrmlsImg = require('./DisclosureImages/cvrmls.png');
const reinImg = require('./DisclosureImages/rein.png');
const tmlsImg = require('./DisclosureImages/tmls.png');
const newDate = new Date();
const month = (newDate.getMonth() + 1).toString();
const day = newDate.getDate().toString();
const year = newDate.getFullYear().toString();
const Bright = {
	image: brightImg,
	alt: 'Bright MLS logo',
	text: `The property information being provided on or through the website is for the personal, non-commercial use of consumers and such information may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Some properties which appear for sale on the website may no longer be available because they are for instance, under contract, sold or are no longer being offered for sale. Property information displayed is deemed reliable but is not guaranteed. \u00A9 ${year} Bright MLS, Inc.`
};
const Cvrmls = {
	image: cvrmlsImg,
	alt: 'CVRMLS logo',
	text: `All or a portion of the multiple Listing information is provided by the Central Virginia Regional Multiple Listing Service, LLC, from a copyrighted compilation of Listings. All CVR MLS information provided is deemed reliable but is not guaranteed accurate. The compilation of Listings and each individual Listing are \u00A9 ${year} Central Virginia Regional Multiple Listing Service, LLC. All rights reserved.`
};
const Rein = {
	image: reinImg,
	alt: 'REINMLS logo',
	text: `\u00A9 (${year}) REIN Inc. Information Deemed Reliable but Not Guaranteed.\n
  The listings data displayed on this medium comes in part from the Real Estate Information Network Inc. (REIN) and has been authorized by participating listing Broker Members of REIN for display. REIN's listings are based upon Data submitted by its Broker Members, and REIN therefore makes no representation or warranty regarding the accuracy of the Data. All users of REIN's listings database should confirm the accuracy of the listing information directly with the listing agent.\n
  \u00A9 (${year}) REIN Inc. REIN's listings Data and information is protected under federal copyright laws. Federal law prohibits, among other acts, the unauthorized copying or alteration of, or preparation of derivative works from, all or any part of copyrighted materials, including certain compilations of Data and information. COPYRIGHT VIOLATORS MAY BE SUBJECT TO SEVERE FINES AND PENALTIES UNDER FEDERAL LAW.\n
  Some listings may be duplicated in the search results due to the co-mingling of listings from more than one multiple listing service. Should there be different listing information between the duplicated listings; user is advised to verify the accuracy of the listing information before making any financial decisions.\n
  This application does not include information on all of the properties available for sale at this time.`
};
const Triangle = {
	image: tmlsImg,
	alt: 'Triangle MLS logo',
	text: `Information not guaranteed. Brokers make an effort to deliver accurate information, but buyers should independently verify any information on which they will rely in a transaction. The listing broker shall not be responsible for any typographical errors, misinformation, or misprints, and they shall be held totally harmless from any damages arising from reliance upon this data. This data is provided exclusively for consumers' personal, non-commercial use. Listings marked with an icon are provided courtesy of the Triangle MLS, Inc. of North Carolina, Internet Data Exchange Database. Closed (sold) listings may have been listed and/or sold by a real estate firm other than the firm(s) featured on this website. Closed data is not available until the sale of the property is recorded in the MLS. Home sale data is not an appraisal, CMA, competitive or comparative market analysis, or home valuation of any property. \u00A9 ${year} Triangle MLS, Inc. of North Carolina. All rights reserved.`
};
const NoMls = {
	image: '',
	alt: '',
	text: 'No MLS provider listed'
};

const MlsDisclosures = (props: { mlsSource: string | undefined, lastSyncTimestamp: string | undefined, listingStatus: string | undefined }) => {

	const lastSyncDate = props.lastSyncTimestamp ? new Date(props.lastSyncTimestamp) : undefined
	const lastSyncFormat = new Intl.DateTimeFormat('en', {
		dateStyle: 'short',
		timeStyle: 'short'
	});

	const Canopy = {
		image: '',
		alt: 'Canopy MLS logo',
		text:
			`Listings courtesy of Canopy MLS as distributed by MLS GRID.
	Some IDX listings have been excluded from this website.
	${props.listingStatus === 'Closed' ? `
	Properties displayed may be listed or sold by various participants in the MLS.
	`: ''}
	Based on information submitted to the MLS GRID as of ${lastSyncFormat.format(lastSyncDate)}. All data is obtained from various sources and may not have been verified by broker or MLS GRID. Supplied Open House Information is subject to change without notice. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.
	
	The Digital Millennium Copyright Act of 1998, 17 U.S.C. § 512 (the “DMCA”) provides recourse for copyright owners who believe that material appearing on the Internet infringes their rights under U.S. copyright law. If you believe in good faith that any content or material made available in connection with our website or services infringes your copyright, you (or your agent) may send us a notice requesting that the content or material be removed, or access to it blocked. Notices must be sent in writing by email to DMCAnotice@MLSGrid.com. “The DMCA requires that your notice of alleged copyright infringement include the following information: 
	(1) description of the copyrighted work that is the subject of claimed infringement; 
	(2) description of the alleged infringing content and information sufficient to permit us to locate the content; 
	(3) contact information for you, including your address, telephone number and email address; 
	(4) a statement by you that you have a good faith belief that the content in the manner complained of is not authorized by the copyright owner, or its agent, or by the operation of any law; 
	(5) a statement by you, signed under penalty of perjury, that the information in the notification is accurate and that you have the authority to enforce the copyrights that are claimed to be infringed; and 
	(6) a physical or electronic signature of the copyright owner or a person authorized to act on the copyright owner’s behalf. Failure to include all of the above information may result in the delay of the processing of your complaint.  `
	};

	const [mlsData, setMlsData] = useState(NoMls);

	useEffect(() => {

		const mlsSource = mapOriginatingSystemToSource[`${props.mlsSource}`];

		if (mlsSource === 'BRIGHT') {
			setMlsData(Bright);
		} else if (mlsSource === 'CVRMLS') {
			setMlsData(Cvrmls);
		} else if (mlsSource === 'REIN') {
			setMlsData(Rein);
		} else if (mlsSource === 'TMLS') {
			setMlsData(Triangle);
		} else if (mlsSource === 'CMLS') {
			setMlsData(Canopy);
		} else setMlsData(NoMls);
	}, [props.mlsSource]);

	return (
		<div className="home-search__mls-disclosures mt-4">
			<div className="font--sm leading--tight cc-color--gray-600">
				{mlsData.image && (
					<div className="w-100 mb-1">
						<img src={mlsData.image} alt={mlsData.alt} style={{ maxWidth: '4rem' }} />
					</div>
				)}
				<div style={{ whiteSpace: 'pre-line' }}>
					{mlsData.text}
					<br />
					<br />
					{lastSyncDate && `Data last refreshed: ${lastSyncFormat.format(lastSyncDate)}`}
				</div>
			</div>
		</div>
	);
};

export default MlsDisclosures;
